import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import InstallBonusPopup from "@/components/InstallBonusPopup";
import MyNavLink from "@/components/MyNavLink";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { BindUser, SendEvent } from "@/utils/Analytics";
import { FromGameSakaApp, FromStandAlone } from "@/utils/BroswerHelper";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { Toast } from "react-vant";
import style from "./style.less";
import { FunctionalConfig, LocalConfig } from "@/config";

function filterNonDigits(input) {
  const result = input.replace(/\D/g, "");
  return result;
}

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const Login = () => {
  const query = useQuery();
  const isReg = !!query.get("reg");
  const backTo = query.get("back_to");
  const history = useEnhancedHistory();
  const inputRef = useRef(null);
  const pwdInputRef = useRef(null);
  const [password, setPassword] = useState("");
  const [bonus, setBonus] = useState(0);
  const [backToUrl, setBackToUrl] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [phoneErrorShakeNum, setPhoneErrorShakeNum] = useState(0);
  const [passwordError, setPasswordError] = useState("");
  const [passwordErrorShakeNum, setPasswordErrorShakeNum] = useState(0);
  const { getPersist, setPersist } = useContext(PersistContext);
  const nowRegionInfo = LocationInfo();
  const [phone, setPhone] = useState(getPersist("last_phone") ? getPersist("last_phone") : "");
  const agentRid = getPersist("agent_rid") ? getPersist("agent_rid") : "";
  const guid = getPersist("guid") ? getPersist("guid") : "";
  const channel = getPersist("channel") ? getPersist("channel") : null;
  const [formCorrect, setFormCorrect] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isPwdInputFocused, setIsPwdInputFocused] = useState(false);
  
  const elementRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState(0);

  const PasswordErrorTextConst = "Password needs to be 6~16 characters!";
  const PhoneErrorTextConst = "Please enter a valid phone number!";
  const PhoneStartWith0ErrorTextConst = "Send code failed, please check your phone";
  
  useEffect(() => {
    const calculateAspectRatio = () => {
      const element = elementRef.current;
      if (element) {
        const width = element.offsetWidth;
        const height = element.offsetHeight;
        const ratio = width / height;
        setAspectRatio(ratio.toFixed(2));
      }
    };

    calculateAspectRatio();
    window.addEventListener('resize', calculateAspectRatio);

    return () => {
      window.removeEventListener('resize', calculateAspectRatio);
    };
  }, []);

  useEffect(() => {
    if (isReg) {
      SendEvent("enter_reg_page", { from: history.from });
    } else {
      SendEvent("enter_login_page", { from: history.from });
    }
  }, [history.from, isReg]);
  console.log("from", history.from);
  useEffect(() => {
    //有backTo的时候，记住要跳转回去的页面
    if (backTo) {
      setBackToUrl(backTo);
    }
    //没有backTo的时候不管，防止注册登录互切的时候，backTo丢失
    console.log("backTo", backTo);
  }, [backTo]);
  useEffect(() => {
    const handleFocus = () => {
      setIsInputFocused(true);
    };

    const handleBlur = () => {
      setIsInputFocused(false);
    };

    const handlePwdFocus = () => {
      setIsPwdInputFocused(true);
    };

    const handlePwdBlur = () => {
      setIsPwdInputFocused(false);
    };

    const inputElement = inputRef.current;
    const pwdInputElement = pwdInputRef.current;
    if (inputElement) {
      inputElement.addEventListener('focus', handleFocus);
      inputElement.addEventListener('blur', handleBlur);
    }

    if (pwdInputElement) {
      pwdInputElement.addEventListener('focus', handlePwdFocus);
      pwdInputElement.addEventListener('blur', handlePwdBlur);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('focus', handleFocus);
        inputElement.removeEventListener('blur', handleBlur);
      }
      if (pwdInputElement) {
        pwdInputElement.removeEventListener('focus', handlePwdFocus);
        pwdInputElement.removeEventListener('blur', handlePwdBlur);
      }
    };
  }, [inputRef, pwdInputRef]);
  console.log("agentRid", agentRid);
  console.log("channel", channel);
  const formSubmit = (e) => {
    SendEvent(isReg ? "login_page_click_register" : "login_page_click_login");
    console.log("formSubmit");
    console.log(e);
    if (!password) {
      if (!passwordError) {
        setPasswordError(PasswordErrorTextConst);
      }
      setPasswordErrorShakeNum(passwordErrorShakeNum + 1);
      return;
    }
    if (!phone) {
      if (!phoneError) {
        setPhoneError(PhoneErrorTextConst);
      }
      setPhoneErrorShakeNum(phoneErrorShakeNum + 1);
      return;
    }
    let fullPhone = nowRegionInfo.phoneStartsWith + phone;
    if (isReg) {
      //发送验证码请求
      Toast.loading({
        message: "Sending Sms Code...",
        forbidClick: true,
        duration: 15000,
        onOpened: () => {
          SendCMD("sendVerificationCode", {
            phone: fullPhone,
          })
            .then((res) => {
              Toast.clear();
              if (!res.status) {
                setPhoneError("Send code failed, please check your phone");
                SendEvent("send_code_failed");
                return;
              }
              SendEvent("send_code_success");
              history.push(ChannelRemind(`./sendRegCode?phone=${phone}&password=${password}`));
            })
            .catch((err) => {
              Toast.clear();
              console.log(err);
              setPhoneError("Send code failed, please check your phone");
              SendEvent("send_code_failed");
            });
        },
      });
    } else {
      //登录请求
      let platform = "1";
      if (FromGameSakaApp) {
        platform = "2";
      }
      if (FromStandAlone) {
        platform = "3";
      }
      SendCMD("login", {
        plat: platform,
        location: getPersist("location"),
        device_type: "h5",
        device_imei: "",
        rolename: phone,
        role_account: fullPhone,
        login_passwd: password,
        login_type: "PASSWD",
        referrer: "",
        promocode: "",
        invite_wheel_guid: guid,
      }).then((res) => {
        if (!res.status) {
          console.log(res.errdesc);
          switch (res.errdcode) {
            case "login_1":
              setPhoneError("Login is not available during this period");
              return;
            case "login_5":
            case "player_login_1":
              setPasswordError("We don't currently offer services in your region");
              return;
            case "player_login_2":
              setPasswordError("Phone or password incorrect, please try again");
              return;
          }
        } else {
          setPersist("last_phone", phone);
          onLoginSuccess(res);
        }
        console.log(res);
      });
    }
    e.preventDefault();
  };

  const onLoginSuccess = (res) => {
    console.log(res.player_info);
    setPersist("user_info", res.player_info);
    if (res.player_info) {
      //登录后根据用户tag强制设置，也就是说，可能会被清掉，这是预期的。
      setPersist("abtest_tag", res.player_info.abtest_tag);
    }
    setPersist("gatesvr", res.gatesvr);
    SendEvent("login", { method: "phone" });
    BindUser(res.player_info.rid);
    //人如果有bonus，就弹出来，然后再跳转
    if (res.player_info.bonus) {
      setBonus(res.player_info.bonus / 100);
    } else {
      finishRedirect();
    }
  };

  const finishRedirect = () => {
    //如果可以返回，直接返回，否则回到大厅
    let lastUrl = getPersist("login_back_url");
    if (lastUrl) {
      setPersist("login_back_url", null);
      console.log("will back to lastUrl", lastUrl);
      history.replace(lastUrl);
    } else {
      history.replace(ChannelRemind("/home"));
    }
  };

  useEffect(() => {
    if (password && !passwordError && phone && !phoneError) {
      setFormCorrect(() => true);
    } else {
      setFormCorrect(() => false);
    }
  }, [phone, password, passwordError, phoneError]);
  return (
    <div class={style.login_container} ref={elementRef}>
      <HomeHeaderOther backToUrl={backToUrl} title={isReg ? "Register" : ""} />
      <div class={style.anim_div}>
        <div className={style.background_image_b}>
        <img src={require("@/assets/images/home/bg2.png").default} className={style.image_b} />
        </div>
      </div>

      {/* <div class={style.login_fast_login}>
        <div class={`${style.login_fast_login_btn} ${style.fb_btn}`}>
          <img src={require("@/assets/icons/fb.svg").default} />
          <div>Sign {isReg ? "up" : "in"} with Facebook</div>
        </div>
        <div class={`${style.login_fast_login_btn} ${style.google_btn}`}>
          <img src={require("@/assets/icons/google.svg").default} />
          <div>Sign {isReg ? "up" : "in"} with Google</div>
        </div>
      </div>
      <div class={style.divider} /> */}
      <div class={style.form_div}>
        <div class={style.form_middle_div}>
          <div class={style.login_title}>Welcome to GameSaka</div>
          <div class={style.login_logo}>
            <img src={require("@/assets/icon.png").default} style={{ height: "1.2rem", marginRight: ".4rem" }} />
            <img
              src={require("@/assets/images/header/fz_char_logo.png").default}
              style={{ height: ".655rem", marginRight: ".7rem" }}
            />
          </div>
          <div class={style.login_form}>
            <div class={style.login_form_input}>
              <div class={style.phone_before}>
                <img src={nowRegionInfo.flag} />
              </div>
              <span style={{
                display: "block",
                position: "absolute",
                left: "5.8rem",
                color: "#fff",
                fontWeight: "700",
                fontSize: "0.9rem",
              }}>
                00{nowRegionInfo.phoneStartsWith}
              </span>
              <input
                class={style.auth_input}
                ref={inputRef}
                type="tel"
                maxLength={nowRegionInfo.phoneNumberDigits || 9}
                placeholder="Enter 9-digits phone number"
                style={{marginLeft:"0.2rem", paddingLeft:"3rem"}}
                defaultValue={getPersist("last_phone")}
                onClick={() => {
                  SendEvent("click_phone_input");
                }}
                onChange={(e) => {
                  let value = e.target.value;
                  value = filterNonDigits(value);
                  if (inputRef.current && inputRef.current.value !== value) {
                    inputRef.current.value = value;
                  }
                  let regexString = `^[1-9]{1}[0-9]{${(nowRegionInfo.phoneNumberDigits || 9) - 1}}$`;
                  let regex = new RegExp(regexString);
                  if (value.startsWith("0")) {
                    setPhone("");
                    setPhoneError(PhoneStartWith0ErrorTextConst);
                  } else if (regex.test(value)) {
                    SendEvent("phone_input_complete");
                    setPhone(value);
                    setPhoneError("");
                    setPasswordError("");
                  } else if (value.length > 0) {
                    setPhone("");
                    setPhoneError(PhoneErrorTextConst);
                  } else {
                    setPhone("");
                    setPhoneError("");
                  }
                }}
              />
            </div>
            <div
              class={`${style.login_form_error} ${phoneErrorShakeNum > 0 ? style.shake : ""}`}
              key={`phoneErrorShakeNum${phoneErrorShakeNum}`}
            >
              {phoneError}
            </div>
            <div class={style.login_form_input}>
              <div class={style.pwd_before}>
                <img src={require("@/assets/images/home/icon_lock.png").default} />
              </div>
              <input
                class={style.auth_input}
                ref={pwdInputRef}
                type="password"
                placeholder="Enter your password"
                style={{ marginLeft: "0.2rem" }}
                onClick={() => {
                  SendEvent("click_password_input");
                }}
                onChange={(e) => {
                  let value = e.target.value;
                  let regex = /^[a-zA-Z0-9_-]{6,16}$/;
                  if (regex.test(value)) {
                    SendEvent("password_input_complete");
                    setPassword(value);
                    setPasswordError("");
                  } else if (value.length > 0) {
                    setPassword("");
                    setPasswordError(PasswordErrorTextConst);
                  } else {
                    setPassword("");
                    setPasswordError("");
                  }
                }}
              />
            </div>
            <div
              class={`${style.login_form_error} ${passwordErrorShakeNum > 0 ? style.shake : ""}`}
              key={`passwordErrorShakeNum${passwordErrorShakeNum}`}
            >
              {passwordError}
            </div>
            <div
              class={style.login_btn + (formCorrect ? "" : ` ${style.login_btn_disabled}`)}
              type="submit"
              onClick={formSubmit}
            >
              {isReg ? "Create Account" : "Login"}
            </div>
          </div>
          {isReg ? (
            <div class={style.have_account}>
              <MyNavLink to="/login" replace={true} style={{ height: "2rem" }}>
                <span>Already have an account? Login</span>
              </MyNavLink>
            </div>
          ) : (
            <div class={style.forgot_password}>
              <MyNavLink to="/forgot" style={{ height: "2rem" }}>
                <span>Forgot Password?</span>
              </MyNavLink>
              <MyNavLink to="/login?reg=1" replace={true} style={{ height: "2rem" }}>
                <span>Create New Account</span>
              </MyNavLink>
            </div>
          )}
        </div>
      </div>
      {console.log("isInputFocused", isInputFocused)}
      {console.log("isPwdInputFocused", isPwdInputFocused)}
      {console.log("aspectRatio", aspectRatio)}
      {(isInputFocused || isPwdInputFocused) && aspectRatio > 0.7 ? (<></>) : (
        <div class={style.login_bottom}>
        <img class={style.footer_18_plus} src={require("@/assets/images/home/18_plus.png").default} />
        <div class={style.footer}>
          <span class={style.footer_tips}>© {LocalConfig.gameName} all right reserved</span>
        </div>
        <div class={style.login_ad} onClick={() => history.push(ChannelRemind("/downloadApp"))}>
          <img src={require("@/assets/images/home/login_ad.png").default} style={{ width: "100%" }} />
        </div>
      </div>      
      )}

      <InstallBonusPopup
        showPopup={bonus > 0}
        amount={bonus}
        onClose={() => {
          setBonus(0);
          finishRedirect();
        }}
      />
    </div>
  );
};

export default Login;
